<v-dialog v-model="isVisible" max-width="30%" @click:outside="cancel">
    <v-card class="pa-5" height="max-content">
        <h2>{{ blacklistEntryId ? "Edit entry" : "Create new entry" }}</h2>
        <v-form class="mt-1" ref="form" @submit.prevent="submit">
            <BlacklistEditor
                v-model:blacklist-model="currentBlacklistModel" />
            <v-row>
                <v-btn color="primary" class="mr-3" type="submit">
                    {{ blacklistEntryId ? "Edit" : "Create" }}
                </v-btn>
                <v-btn color="red" @click="cancel">Cancel</v-btn>
            </v-row>
        </v-form>
    </v-card>
</v-dialog>